import session from "./session";

export default {
  postChangeTariff(data) {
    return session.patch(`/products/${data.product.id}/actions/change-tariff/`,JSON.stringify(data));
  },
  fetchTelcoTariffs() {
    return session.get(`/pricing/tariffs/?tariff_version=2&product_kind=TELCO`);
  },
  fetchTelcoAddons() {
    return session.get(`/pricing/addons/?product_kind__in=TELCO&tariff_version=2`);
  },
}
